import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { withLocalize } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import NoDataComponent from "../../common/noDataComponent";
import BbPopover from '../../common/popover';
import UnderlinedTitle from '../../common/underlinedTitle';
import EsgAverageLine from './esgAverageLine';

class ESGScoreAverage extends React.Component {

    render() {
        const { data } = this.props;
        return isNullOrUndefined(data) ? <NoDataComponent /> : this.renderContent();
    }

    renderContent() {
        const { data, sectorIdentificator, primaryAttrCountry } = this.props;
        const averagePopoverId = `header-tooltip-average`;

        return (
            <div className='esg-block-statistics'>
                <div className='header'>
                    <UnderlinedTitle header={this.props.translate(this.getTranslationKey())} />
                    <span>
                        <BbPopover
                            title={this.props.translate(this.getTranslationKey())}
                            content={this.getTooltip()}
                            placement="left"
                            targetId={averagePopoverId}
                        >
                            <span href="#" className="icon-gray print-hidden" id={averagePopoverId} style={{ cursor: "pointer" }}><FontAwesomeIcon icon="question-circle" /></span>
                        </BbPopover>
                    </span>
                </div>
                <div className='average-content'>
                    <EsgAverageLine id="esg-average-line" data={data} sectorIdentificator={sectorIdentificator} primaryAttrCountry={primaryAttrCountry} />
                </div>
            </div>
        );
    }

    getTranslationKey = () => `Report.ESG.ScoreDetail.Average`;

    getTooltip = () => ReactHtmlParser(this.props.translate(`${this.getTranslationKey()}.Tooltip.${this.props.primaryAttrCountry}`, { sectorId: this.props.sectorIdentificator }));
}

ESGScoreAverage.propTypes = {
    data: PropTypes.shape({
        market_avg: PropTypes.number,
        sector_avg: PropTypes.number,
    }).isRequired,
    sectorIdentificator: PropTypes.string,
    primaryAttrCountry: PropTypes.oneOf(["CZ", "SK"])
};

ESGScoreAverage.defaultProps = {
    data: null,
    sectorIdentificator: "",
    primaryAttrCountry: "CZ"
};

export default withLocalize(ESGScoreAverage);